/* eslint-disable no-new */

import App from "./App.svelte";

class GrundsteuerChecker extends HTMLElement {
  constructor() {
    super();

    this.attachShadow({ mode: "open" });
    this.linkCSS();
    this.createApp();
  }

  linkCSS() {
    const scriptURL = import.meta.url;
    const cssURL = new URL("index.css", scriptURL).href;
    const styles = document.createElement("link");
    styles.setAttribute("rel", "stylesheet");
    styles.setAttribute("href", cssURL);
    this.shadowRoot.appendChild(styles);
  }

  createApp() {
    const target = this.shadowRoot;
    const dataPath = this.getAttribute("data-path");
    const postalCodesPath = this.getAttribute("postal-codes-path");
    new App({ target, props: { dataPath, postalCodesPath } });
  }
}

// Directly create Svelte app in development mode. This is necessary to avoid
// complications with styles which are inserted globally by Vite.
if (import.meta.env.DEV) {
  const target = document.querySelector("grundsteuer-checker");
  const dataPath = target.getAttribute("data-path");
  const postalCodesPath = target.getAttribute("postal-codes-path");
  new App({ target, props: { dataPath, postalCodesPath } });
}

// Encapsulate the Svelte app inside a custom element to avoid style conflict
// with the host website.
if (import.meta.env.PROD) {
  customElements.define("grundsteuer-checker", GrundsteuerChecker);
}
